import { EGestaoTarefasEtapa } from '@/utils/helpers/enums/gestao-tarefas/GestaTarefasEtapas';

export default {
  draggedItem: {},
  responsaveisTrust: [],
  responsaveisComex: [],
  configuracoesModal: [
    {
      etapa: EGestaoTarefasEtapa.PENDENTE,
      titulo: 'tarefasProcessoPendente',
      tamanhoModal: 600,
    },
    {
      etapa: EGestaoTarefasEtapa.ADMINISTRATIVO,
      titulo: 'tarefasTratamentoAdministrativo',
      tamanhoModal: 1000,
    },
    {
      etapa: EGestaoTarefasEtapa.REGULATORIOCADASTRONOVOPRODUTO,
      titulo: 'regulatorioCadastroNovoProduto',
      tamanhoModal: 1000,
    },
    {
      etapa: EGestaoTarefasEtapa.ACOMPANHAMENTO,
      titulo: 'tarefasAcompanhamento',
      tamanhoModal: 1000,
    },
    {
      etapa: EGestaoTarefasEtapa.NACIONALIZACAO,
      titulo: 'tarefasNacionalizacao',
      tamanhoModal: 1000,
    },
    {
      etapa: EGestaoTarefasEtapa.FECHAMENTO,
      titulo: 'tarefasFechamento',
      tamanhoModal: 1000,
    },
    {
      etapa: EGestaoTarefasEtapa.CANCELAMENTOS,
      titulo: 'tarefasCancelamentos',
      tamanhoModal: 1000,
    },
  ],
  headersProdutoNCM: [
    {
      text: 'NCM',
      align: 'start',
      sortable: false,
      value: 'codigoNCM',
    },
    {
      text: 'Produto',
      align: 'start',
      sortable: false,
      value: 'nomeProduto',
    },
  ],
  listaResponsaveis: [],
  cards: {},
  cardSelecionado: {},
  hasInterval: true,
  mostrarConcluidos: false,
};
